import { render } from "./low-stocks.vue?vue&type=template&id=4310ac92"
import script from "./low-stocks.vue?vue&type=script&lang=js"
export * from "./low-stocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__